import React from 'react'
import type { TooltipProps } from 'recharts'
import type { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'
import type { StatDefinition } from './careerProgressionChart.types'
import { DescSm } from '../../../../../Components/Typography/Text.styles'
import { CareerTooltipContainer, TooltipPaper } from './styles'
import { ConvertStatValue } from '../../../../../Utils'

type CareerTooltipProps = TooltipProps<ValueType, NameType> & {
  showPerGameStats: boolean
  availableStats: StatDefinition[]
}

export const CareerTooltip: React.FC<CareerTooltipProps> = ({
  active,
  payload,
  label,
  availableStats,
}) => {
  if (active && payload?.length) {
    return (
      <TooltipPaper>
        <DescSm>Year: {label}</DescSm>
        {payload.map((entry) => {
          const statDef = availableStats.find((stat) => stat.key === entry.dataKey)
          const statName = statDef ? statDef.name : entry.name
          const value = statDef
            ? ConvertStatValue(entry.value, statDef.key ?? 'points')
            : entry.value

          return (
            <CareerTooltipContainer key={entry.dataKey} entryColor={entry.color}>
              <div className="inner">
                <div className="indicator" />
                <DescSm sx={{ color: entry.color }}>
                  {statName}: {value}
                </DescSm>
              </div>
            </CareerTooltipContainer>
          )
        })}
      </TooltipPaper>
    )
  }

  return null
}
